import type { CurrencyCode } from '@/shared/lib/currency';

export const useSeoStore = defineStore('seo', () => {
  const DEFAULT_IMAGE_LINK = 'https://experience.tripster.ru/static/i/tripster-share-logo.jpg';

  const resizeImage = ref(DEFAULT_IMAGE_LINK);
  const secondExpImage = ref('');
  const thirdExpImage = ref('');
  const tagCanonicalUrl = ref('');
  const lowPrice = ref(0);
  const highPrice = ref(0);
  const priceCurrency = ref<CurrencyCode>('RUB');
  const reviewCount = ref(0);
  const ratingValue = ref(0);

  const setResizeImage = (img: string | undefined) => {
    if (img) {
      resizeImage.value = img;
    } else {
      resizeImage.value = DEFAULT_IMAGE_LINK;
    }
  };

  const setTagCanonicalUrl = (url: string) => {
    if (url) {
      tagCanonicalUrl.value = url;
    }
  };

  const setPriceInfo = (low: number, high: number, currency: CurrencyCode) => {
    lowPrice.value = low || 0;
    highPrice.value = high || 0;
    priceCurrency.value = currency || 'RUB';
  };

  const setReviewCount = (value: number) => {
    reviewCount.value = value || 0;
  };

  const setRatingValue = (value: number) => {
    ratingValue.value = value || 0;
  };

  const setSecondExpImage = (value: string | undefined) => {
    secondExpImage.value = value || '';
  };

  const setThirdExpImage = (value: string | undefined) => {
    thirdExpImage.value = value || '';
  };

  return {
    resizeImage,
    tagCanonicalUrl,
    setResizeImage,
    setTagCanonicalUrl,
    setPriceInfo,
    priceCurrency,
    lowPrice,
    highPrice,
    reviewCount,
    ratingValue,
    setReviewCount,
    setRatingValue,
    secondExpImage,
    thirdExpImage,
    setSecondExpImage,
    setThirdExpImage,
  };
});
